export interface IListagemDadosVariaveis {
  TagDadosVariaveis: string;
  NomeDadosVariaveis: string;
  TamMaxDadosVariaveis: number;
  DescDadosVariaveis: string;
  ROW_NUM?: number;
}
export interface IListagemLogDadosVariaveis {
  USU_NM:string;
  UsuId:number;
  DhUsuario: Date;
  TagDadosVariaveis: string;
  NomeDadosVariaveis: string;
  TamMaxDadosVariaveis: number;
  DescDadosVariaveis: string;
  Acao: string;
  
}
export interface IResponseLogDadosVariaveis {
  rows: IListagemLogDadosVariaveis[];
  count: number;
}

export interface ICreateDadosVariaveis {
  TagDadosVariaveis?: string;
  NomeDadosVariaveis?: string;
  TamMaxDadosVariaveis?: number;
  DescDadosVariaveis?: string;
}

export interface ICompleteDadosVariaveis {
  TagDadosVariaveis: string;
  NomeDadosVariaveis: string;
  TamMaxDadosVariaveis: number;
}

export interface IResponseDadosVariaveis {
  rows: IListagemDadosVariaveis[];
  count: number;
}

export const InicitalCreateDadosVariaveis = {
  TagDadosVariaveis: '',
  NomeDadosVariaveis: '',
  TamMaxDadosVariaveis: 0,
  DescDadosVariaveis: ''
};